import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import OnboardingBanner from './OnboardingBanner';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen bg-bolt-bg">
      <Header />
      <OnboardingBanner />
      <main className="flex-grow">
        <div className="container-custom py-8">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
